import React, { useEffect } from 'react';
import { ProductIds } from '@/constants/productIds';
import { useLearningContext } from '@/contexts/LearningContext';

export interface TutorialsSubscriberProps {
  productIds: ProductIds[];
}

/**
 * A headless component that registers learning video ProductIds
 * to the LearningProvider while it is mounted.
 * When unmounted, it unregisters them.
 */
const TutorialsSubscriber: React.FC<TutorialsSubscriberProps> = ({ productIds }) => {
  const { registerProductIds, unregisterProductIds } = useLearningContext();

  useEffect(() => {
    if (productIds.length > 0) {
      registerProductIds(productIds);
    }
    return () => {
      if (productIds.length > 0) {
        unregisterProductIds(productIds);
      }
    };
  }, [productIds, registerProductIds, unregisterProductIds]);

  // Headless component, renders no UI.
  return null;
};

export default TutorialsSubscriber;
